import { createClient, type SupabaseClient } from '@supabase/supabase-js'

export interface SupabaseAsyncStorage {
  getItem(key: string): Promise<string | null>
  setItem(key: string, value: string): Promise<void>
  removeItem(key: string): Promise<void>
}

export interface SupabaseClientConfig {
  readonly url: string
  readonly anonKey: string
  /** React Native (Expo) passes AsyncStorage here; web omits it and uses the browser default. */
  readonly storage?: SupabaseAsyncStorage
}

let cachedClient: SupabaseClient | null = null
let cachedConfigKey: string | null = null

/**
 * Config is passed in rather than read from env here, mirroring
 * apps/web/src/infrastructure/firebase/app.ts: the host app (Vite via `VITE_*`, Expo via
 * `EXPO_PUBLIC_*`) owns env var resolution, this package stays bundler-agnostic.
 */
export function getSupabaseClient(config: SupabaseClientConfig): SupabaseClient {
  const configKey = `${config.url}:${config.anonKey}`
  if (!cachedClient || cachedConfigKey !== configKey) {
    cachedClient = createClient(config.url, config.anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        ...(config.storage ? { storage: config.storage, detectSessionInUrl: false } : {}),
      },
    })
    cachedConfigKey = configKey
  }
  return cachedClient
}
